module.exports = __webpack_public_path__ + "static/mission-img-5-88fb78e8f71acc67b5e3375685a67716.jpg";